jQuery(document).ready(function(){

  if(jQuery('#programme-sama-elton').length > 0) {
    const swiperThumbs = new Swiper(".navigation-slider-programme-sama-elton", {
      slidesPerView: "auto",
      spaceBetween: 10,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });
    new Swiper(".main-slider-programme-sama-elton", {
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 30,
      autoplay: { delay: 5000, disableOnInteraction: false },
      pagination: { el: ".swiper-pagination", clickable: true },
      thumbs: { swiper: swiperThumbs },
    });

  }
})
